/* eslint-disable import/prefer-default-export */
import React from 'react';
import RIQButton from '../../../components/RIQButton.jsx';
import {
    RIQPopover
} from '../../../components/RIQPopover.jsx';

import {
    useCurationConfigValue
} from '../../../hooks/widgetConfiguration.js';

import {
    useListAccountSavedSearches
} from '../hooks/useListeningQueryPersistence.js';
import {
    listeningDefinitions
} from './enums/listeningDefinitions.jsx';

export function CreateSavedSearchButton({instanceId}) {

    const plan = useCurationConfigValue('plan');
    const numSavedSearchesAllowed = plan?.max_listening_saved_searches;
    const {data: allSavedSearches} = useListAccountSavedSearches();
    const hasTopicCreation = (plan?.has_full_instant_search && numSavedSearchesAllowed > 0);
    const canCreateMoreSearches = Boolean(hasTopicCreation && allSavedSearches && allSavedSearches.length < numSavedSearchesAllowed);

    const {
        outOfTopics,
        topicsUnsupported
    } = listeningDefinitions[instanceId] || {};

    let tooltip;
    if (hasTopicCreation) {
        tooltip = outOfTopics(numSavedSearchesAllowed);
    } else {
        tooltip = topicsUnsupported;
    }

    return (
        <div className='tlw-mb-20 tlw-flex tlw-flex-col tlw-items-end'>
            {canCreateMoreSearches &&
                <ButtonElement/>
            }
            {!canCreateMoreSearches &&
                <RIQPopover
                    triggerNode={
                        <ButtonElement
                            disabled={true}
                        />}
                    placement='left'
                    variant='tooltip'
                >
                    {tooltip}
                </RIQPopover>
            }
        </div>
    );
}

function ButtonElement({disabled}) {

    function onCreateSavedSearchClick() {
        RivalIQ.execute('history:navigate', 'listening/savedsearchbuilder', {
            trigger: true
        });
    }
    return (
        <RIQButton
            onClick={onCreateSavedSearchClick}
            variant='primary'
            className='tlw-px-6 tlw-py-3 tlw-text-md tlw-font-normal'
            disabled={disabled}
        >
            <span className='fa fa-plus fa-fw' />
        &nbsp;Create New Search
        </RIQButton>
    );
}
